import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { Row, Col } from 'reactstrap'
import SocialMediaLinks from './SocialMediaLinks'
import styles from './Footer.module.scss'
import SubscribeToNewsletter from '../SubscribeToNewsletter'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const data = useStaticQuery(graphql`
    query footerQuery {
      footerLinks: allDatoCmsPsFooterGrid {
        edges {
          node {
            id
            title
            column {
              id
              label
              url
            }
          }
        }
      }
    }
  `)
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.navLinks}>
          <Row>{data.footerLinks.edges.map(renderColumn)}</Row>
        </div>

        {/* Should be shown after implementation of functionality of external form */}
        <SubscribeToNewsletter />

        <Row>
          <Col sm={1}>
            <svg
              width="71"
              height="18"
              viewBox="0 0 71 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.76855 1.31592V1.69629L4.13574 2.32715L6.71484 12.2817H6.79834L10.1567 1.31592H11.3535L14.4707 12.0776H14.5449L17.1519 2.3457L15.5376 1.69629V1.31592H19.9814V1.69629L18.3672 2.36426L14.8511 15.1855H13.979L10.4629 4.48877H10.4072L7.09521 15.1855H6.09326L2.23389 2.36426L0.526855 1.69629V1.31592H5.76855ZM25.6499 14.6196V15H20.5195V14.6196L22.2266 13.9517V6.98438L20.5195 6.31641V5.93604L23.748 5.26807L23.9429 5.46289V13.9517L25.6499 14.6196ZM21.605 2.47559C21.605 2.15397 21.7163 1.88184 21.939 1.65918C22.1678 1.43034 22.4492 1.31592 22.7832 1.31592C23.1048 1.31592 23.377 1.43034 23.5996 1.65918C23.8285 1.88184 23.9429 2.15397 23.9429 2.47559C23.9429 2.80957 23.8285 3.09098 23.5996 3.31982C23.377 3.54248 23.1048 3.65381 22.7832 3.65381C22.4492 3.65381 22.1678 3.54248 21.939 3.31982C21.7163 3.09098 21.605 2.80957 21.605 2.47559ZM31.7266 14.6196V15H26.7817V14.6196L28.498 13.9517V2.23438L26.7817 1.56641V1.18604L30.0195 0.518066L30.2051 0.712891V9.81396L31.04 9.61914L33.814 6.35352L32.5986 5.88037V5.5H36.6436V5.88037L35.0479 6.51123L32.3296 9.70264L35.5674 13.9702V13.9517L37.1816 14.6196V15H34.3521L30.873 10.519H30.2051V13.9517L31.7266 14.6196ZM43.1655 14.6196V15H38.0352V14.6196L39.7422 13.9517V6.98438L38.0352 6.31641V5.93604L41.2637 5.26807L41.4585 5.46289V13.9517L43.1655 14.6196ZM39.1206 2.47559C39.1206 2.15397 39.2319 1.88184 39.4546 1.65918C39.6834 1.43034 39.9648 1.31592 40.2988 1.31592C40.6204 1.31592 40.8926 1.43034 41.1152 1.65918C41.3441 1.88184 41.4585 2.15397 41.4585 2.47559C41.4585 2.80957 41.3441 3.09098 41.1152 3.31982C40.8926 3.54248 40.6204 3.65381 40.2988 3.65381C39.9648 3.65381 39.6834 3.54248 39.4546 3.31982C39.2319 3.09098 39.1206 2.80957 39.1206 2.47559ZM47.9526 2.36426V12.8755C47.9526 14.0692 47.6248 15.0433 46.9692 15.7979C46.3136 16.5524 45.3055 17.1214 43.9448 17.5049L43.8799 16.9019C44.7581 16.4009 45.355 15.8535 45.6704 15.2598C45.9858 14.6722 46.1436 13.8249 46.1436 12.7178V2.36426L44.4365 1.69629V1.31592H49.5669V1.69629L47.9526 2.36426ZM55.4395 5.26807C56.1445 5.26807 56.7785 5.38867 57.3413 5.62988C57.9041 5.87109 58.3804 6.21126 58.77 6.65039C59.1597 7.08333 59.4565 7.60596 59.6606 8.21826C59.8709 8.83057 59.9761 9.50781 59.9761 10.25C59.9761 10.986 59.874 11.6602 59.6699 12.2725C59.4658 12.8848 59.1689 13.4105 58.7793 13.8496C58.3896 14.2887 57.9134 14.6289 57.3506 14.8701C56.7878 15.1113 56.1507 15.2319 55.4395 15.2319C54.722 15.2319 54.0819 15.1113 53.519 14.8701C52.9562 14.6289 52.48 14.2887 52.0903 13.8496C51.7007 13.4105 51.4038 12.8879 51.1997 12.2817C50.9956 11.6694 50.8936 10.9922 50.8936 10.25C50.8936 9.50781 50.9956 8.83057 51.1997 8.21826C51.41 7.60596 51.71 7.08333 52.0996 6.65039C52.4893 6.21126 52.9655 5.87109 53.5283 5.62988C54.0911 5.38867 54.7282 5.26807 55.4395 5.26807ZM53.417 7.23486C52.9408 8.00798 52.7026 9.01302 52.7026 10.25C52.7026 10.8623 52.7614 11.4251 52.8789 11.9385C53.0026 12.4456 53.1789 12.8848 53.4077 13.2559C53.6427 13.6208 53.9303 13.9053 54.2705 14.1094C54.6107 14.3135 55.0003 14.4155 55.4395 14.4155C55.8786 14.4155 56.2713 14.3135 56.6177 14.1094C56.964 13.9053 57.2547 13.6208 57.4897 13.2559C57.731 12.8848 57.9134 12.4456 58.0371 11.9385C58.167 11.4251 58.2319 10.8623 58.2319 10.25C58.2319 9.64388 58.167 9.08724 58.0371 8.58008C57.9134 8.06673 57.731 7.6276 57.4897 7.2627C57.2547 6.8916 56.964 6.604 56.6177 6.3999C56.2713 6.18962 55.8786 6.08447 55.4395 6.08447C54.5612 6.08447 53.887 6.46794 53.417 7.23486ZM63.2139 15.4175H62.6479V2.23438L60.9316 1.56641V1.18604L64.1602 0.518066L64.355 0.712891V6.1123C64.9982 5.54948 65.8394 5.26807 66.8784 5.26807C67.3918 5.26807 67.8896 5.38558 68.3721 5.62061C68.8607 5.84945 69.2936 6.17415 69.6709 6.59473C70.0482 7.00911 70.3512 7.53483 70.5801 8.17188C70.8089 8.80892 70.9233 9.50163 70.9233 10.25C70.9233 11.0417 70.7904 11.7591 70.5244 12.4023C70.2646 13.0456 69.9121 13.5713 69.4668 13.9795C69.0215 14.3815 68.5143 14.6908 67.9453 14.9072C67.3825 15.1237 66.7856 15.2319 66.1548 15.2319C65.3446 15.2319 64.5405 15.0464 63.7427 14.6753L63.2139 15.4175ZM66.2012 6.22363C65.4714 6.22363 64.856 6.51432 64.355 7.0957V13.4043C64.6642 13.7568 64.9704 13.9919 65.2734 14.1094C65.5827 14.2207 65.9105 14.2764 66.2568 14.2764C66.832 14.2764 67.3299 14.0815 67.7505 13.6919C68.1772 13.3022 68.4896 12.8105 68.6875 12.2168C68.8916 11.6169 68.9937 10.9613 68.9937 10.25C68.9937 9.06868 68.737 8.10384 68.2236 7.35547C67.7165 6.60091 67.0423 6.22363 66.2012 6.22363Z"
                fill="white"
              />
            </svg>
          </Col>
          <Col sm={3}>
            <div className={styles.socialMediaLinks}>
              <SocialMediaLinks />
            </div>
          </Col>
          <Col sm={8}>
            <p className={styles.copyright}>
              © WikiJob 2007-{currentYear}. All rights reserved.
            </p>
          </Col>
        </Row>
      </div>
    </footer>
  )
}

const renderColumn = ({ node: { id, title, column } }) => (
  <Col key={id} className={styles.column}>
    <div className={styles.columnHeading}>{title}</div>
    {column.map(renderLink)}
  </Col>
)

const renderLink = ({ id, label, url }) => (
  <div key={id}>
    <Link className="footerLink" to={url}>
      {label}
    </Link>
  </div>
)

export default Footer
